import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const Sellers = () => {
    return (
        <div className="seller-box">
            <div className="sellers-single-page-wrapper xmt-lg-16 d-none d-lg-block">
                <div className="container container-xl-small">
                    <div className="input-filter-seller">
                        <select className="form-select">
                            <option value="1">ارزان ترین</option>
                            <option value="2">بهترین</option>
                            <option value="3">نزدیک ترین</option>
                        </select>
                    </div>
                    <div className="sellers-list-wrapper xmt-6">
                        <ul className="list-unstyled xp-4 sellers-list">
                            <li className="active seller-item">
                                <div className="row">
                                    <div className="col-5">
                                        <div className="seller-name">
                                            <IconName name="vendor" className="icon seller-item-icon"/>
                                            <span className="name">کامپیوتر زرد آذربایجان</span>
                                            <span className="ok-seller">
                                        <IconName name="check" className="icon"/>
                                        فروشنده برگزیده
                                    </span>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="seller-function position-relative">
                                            <span className="function">عملکرد ۳.۴ از ۵</span>
                                            <div className="popover-seller position-absolute">
                                                <div className="name-seller">
                                                    <span className="name">کامپیوتر زرد آذربایجان</span>
                                                    <span className="ok-seller">
                                                    <IconName name="check" className="icon"/>
                                        فروشنده برگزیده
                                                </span>
                                                </div>
                                                <div className="member-ship">
                                                    <p
                                                        className="text"><span>عملکرد ۳.۴ از ۵</span>(عضویت از ۱ سال، ۶
                                                        ماه
                                                        پیش) </p>
                                                </div>
                                                <div className="score-seller">
                                                    <ul className="nav">
                                                        <li className="nav-item">
                                                            <span className="score persian-number good-score">100%</span>
                                                            <span className="text-score">تامین به موقع</span>
                                                        </li>
                                                        <li className="nav-item">
                                                            <span className="score persian-number bad-score">93.4%</span>
                                                            <span className="text-score">تعهد ارسال</span>
                                                        </li>
                                                        <li className="nav-item">
                                                            <span className="score persian-number good-score">95%</span>
                                                            <span className="text-score">بدون مرجوعی</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="supply">
                                            <IconName name="verified_user" className="icon"/>
                                            <span className="supply-text">مرکز تامین کالای ایران</span>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="total-price persian-number">
                                            <IconName name="add" className="icon"/>
                                            <span>5,489,000 ت</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="seller-item">
                                <div className="row">
                                    <div className="col-5">
                                        <div className="seller-name">
                                            <IconName name="vendor" className="icon seller-item-icon"/>
                                            <span className="name">زندگی مدرن</span>
                                            <span className="send-product">
                                        <IconName name="moped" className="icon"/>
                                        ارسال کالا از ۱ روز کاری آینده
                                    </span>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="seller-function position-relative">
                                            <span className="function">عملکرد ۳.۴ از ۵</span>
                                            <div className="popover-seller position-absolute">
                                                <div className="name-seller">
                                                    <span className="name">کامپیوتر زرد آذربایجان</span>
                                                    <span className="ok-seller">
                                                    <IconName name="check" className="icon"/>
                                        فروشنده برگزیده
                                                </span>
                                                </div>
                                                <div className="member-ship">
                                                    <p
                                                        className="text"><span>عملکرد ۳.۴ از ۵</span>(عضویت از ۱ سال، ۶
                                                        ماه
                                                        پیش) </p>
                                                </div>
                                                <div className="score-seller">
                                                    <ul className="nav">
                                                        <li className="nav-item">
                                                            <span className="score persian-number good-score">100%</span>
                                                            <span className="text-score">تامین به موقع</span>
                                                        </li>
                                                        <li className="nav-item">
                                                            <span className="score persian-number bad-score">93.4%</span>
                                                            <span className="text-score">تعهد ارسال</span>
                                                        </li>
                                                        <li className="nav-item">
                                                            <span className="score persian-number good-score">95%</span>
                                                            <span className="text-score">بدون مرجوعی</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="supply">
                                            <IconName name="verified_user" className="icon"/>
                                            <span className="supply-text">مرکز تامین کالای ایران</span>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="total-price persian-number">
                                            <IconName name="add" className="icon"/>
                                            <span>5,489,000 ت</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="seller-item">
                                <div className="row">
                                    <div className="col-5">
                                        <div className="seller-name">
                                            <IconName name="vendor" className="icon seller-item-icon"/>
                                            <span className="name">کامپیوتر زرد آذربایجان</span>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="seller-function position-relative">
                                            <span className="function">عملکرد ۳.۴ از ۵</span>
                                            <div className="popover-seller position-absolute">
                                                <div className="name-seller">
                                                    <span className="name">کامپیوتر زرد آذربایجان</span>
                                                    <span className="ok-seller">
                                                    <IconName name="check" className="icon"/>
                                        فروشنده برگزیده
                                                </span>
                                                </div>
                                                <div className="member-ship">
                                                    <p
                                                        className="text"><span>عملکرد ۳.۴ از ۵</span>(عضویت از ۱ سال، ۶
                                                        ماه پیش) </p>
                                                </div>
                                                <div className="score-seller">
                                                    <ul className="nav">
                                                        <li className="nav-item">
                                                            <span className="score persian-number good-score">100%</span>
                                                            <span className="text-score">تامین به موقع</span>
                                                        </li>
                                                        <li className="nav-item">
                                                            <span className="score persian-number bad-score">93.4%</span>
                                                            <span className="text-score">تعهد ارسال</span>
                                                        </li>
                                                        <li className="nav-item">
                                                            <span className="score persian-number good-score">95%</span>
                                                            <span className="text-score">بدون مرجوعی</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="supply">
                                            <IconName name="verified_user" className="icon"/>
                                            <span className="supply-text">مرکز تامین کالای ایران</span>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="total-price persian-number">
                                            <IconName name="add" className="icon"/>
                                            <span>5,489,000 ت</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="seller-item">
                                <div className="row">
                                    <div className="col-5">
                                        <div className="seller-name">
                                            <IconName name="vendor" className="icon seller-item-icon"/>
                                            <span className="name">کامپیوتر زرد آذربایجان</span>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="seller-function position-relative">
                                            <span className="function">عملکرد ۳.۴ از ۵</span>
                                            <div className="popover-seller position-absolute">
                                                <div className="name-seller">
                                                    <span className="name">کامپیوتر زرد آذربایجان</span>
                                                    <span className="ok-seller">
                                                    <IconName name="check" className="icon"/>
                                        فروشنده برگزیده
                                                </span>
                                                </div>
                                                <div className="member-ship">
                                                    <p
                                                        className="text"><span>عملکرد ۳.۴ از ۵</span>(عضویت از ۱ سال، ۶
                                                        ماه پیش) </p>
                                                </div>
                                                <div className="score-seller">
                                                    <ul className="nav">
                                                        <li className="nav-item">
                                                            <span className="score persian-number good-score">100%</span>
                                                            <span className="text-score">تامین به موقع</span>
                                                        </li>
                                                        <li className="nav-item">
                                                            <span className="score persian-number bad-score">93.4%</span>
                                                            <span className="text-score">تعهد ارسال</span>
                                                        </li>
                                                        <li className="nav-item">
                                                            <span className="score persian-number good-score">95%</span>
                                                            <span className="text-score">بدون مرجوعی</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="supply">
                                            <IconName name="verified_user" className="icon"/>
                                            <span className="supply-text">مرکز تامین کالای ایران</span>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="total-price persian-number">
                                            <IconName name="add" className="icon"/>
                                            <span>5,489,000 ت</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="seller-item">
                                <div className="row">
                                    <div className="col-5">
                                        <div className="seller-name">
                                            <IconName name="vendor" className="icon seller-item-icon"/>
                                            <span className="name">کامپیوتر زرد آذربایجان</span>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="seller-function position-relative">
                                            <span className="function">عملکرد ۳.۴ از ۵</span>
                                            <div className="popover-seller position-absolute">
                                                <div className="name-seller">
                                                    <span className="name">کامپیوتر زرد آذربایجان</span>
                                                    <span className="ok-seller">
                                                    <IconName name="check" className="icon"/>
                                        فروشنده برگزیده
                                                </span>
                                                </div>
                                                <div className="member-ship">
                                                    <p
                                                        className="text"><span>عملکرد ۳.۴ از ۵</span>(عضویت از ۱ سال، ۶
                                                        ماه پیش) </p>
                                                </div>
                                                <div className="score-seller">
                                                    <ul className="nav">
                                                        <li className="nav-item">
                                                            <span className="score persian-number good-score">100%</span>
                                                            <span className="text-score">تامین به موقع</span>
                                                        </li>
                                                        <li className="nav-item">
                                                            <span className="score persian-number bad-score">93.4%</span>
                                                            <span className="text-score">تعهد ارسال</span>
                                                        </li>
                                                        <li className="nav-item">
                                                            <span className="score persian-number good-score">95%</span>
                                                            <span className="text-score">بدون مرجوعی</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="supply">
                                            <IconName name="verified_user" className="icon"/>
                                            <span className="supply-text">مرکز تامین کالای ایران</span>
                                        </div>
                                    </div>
                                    <div className="col-2">


                                        <div className="total-price persian-number">
                                            <IconName name="add" className="icon"/>
                                            <span>5,489,000 ت</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="seller-responsive-wrapper d-block d-lg-none position-fixed">
                <div className="header-seller-responsive xpy-3 xpx-4">
                    <div className="back-seller-responsive">
                        <IconName name="arrow_back" className="icon"/>
                        <span className="text-header">فروشندگان</span>
                    </div>
                </div>
                <div className="content-sellers-responsive">
                    <div className="seller-box-responsive active">
                        <div className="name-seller position-relative">
                            <IconName name="vendor" className="icon icon-seller"/>
                            <span className="name">کامپیوتر زرد آذربایجان</span>
                            <span className="ok-seller">
                                <IconName name="check" className="icon"/>
                                برگزیده
                            </span>
                            <IconName name="chevron_left" className="icon more-sellers position-absolute"/>
                        </div>
                        <div className="function-seller">
                            <IconName name="stars" className="icon"/>
                            <p><span>عملکرد ۳.۴ از ۵</span> (عضویت از ۱ سال، ۶ ماه پیش)</p>
                            <div className="score-sellers">
                                <ul className="nav">
                                    <li className="nav-item">
                                        <span className="score persian-number good-score">100%</span>
                                        <span className="text-score">تامین به موقع</span>
                                    </li>
                                    <li className="nav-item">
                                        <span className="score persian-number bad-score">93.4%</span>
                                        <span className="text-score">تعهد ارسال</span>
                                    </li>
                                    <li className="nav-item">
                                        <span className="score persian-number good-score">95%</span>
                                        <span className="text-score">بدون مرجوعی</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="register-product">
                            <IconName name="verified_user" className="icon"/>
                            <span>تضمین ثبت در شبکه رجیستری بدون هزینه …</span>
                        </div>
                        <div className="total-price persian-number">
                            <IconName name="cart" className="icon"/>
                            <span>5,480,000 ت</span>
                        </div>
                    </div>
                    <div className="seller-box-responsive">
                        <div className="name-seller position-relative">
                            <IconName name="vendor" className="icon icon-seller"/>
                            <span className="name">کامپیوتر زرد آذربایجان</span>
                            <span className="ok-seller">
                                <IconName name="check" className="icon"/>
                                برگزیده
                            </span>
                            <IconName name="chevron_left" className="icon more-sellers position-absolute"/>
                        </div>
                        <div className="function-seller">
                            <IconName name="stars" className="icon"/>
                            <p><span>عملکرد ۳.۴ از ۵</span> (عضویت از ۱ سال، ۶ ماه پیش)</p>
                            <div className="score-sellers">
                                <ul className="nav">
                                    <li className="nav-item">
                                        <span className="score persian-number good-score">100%</span>
                                        <span className="text-score">تامین به موقع</span>
                                    </li>
                                    <li className="nav-item">
                                        <span className="score persian-number bad-score">93.4%</span>
                                        <span className="text-score">تعهد ارسال</span>
                                    </li>
                                    <li className="nav-item">
                                        <span className="score persian-number good-score">95%</span>
                                        <span className="text-score">بدون مرجوعی</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="register-product">
                            <IconName name="verified_user" className="icon"/>
                            <span>تضمین ثبت در شبکه رجیستری بدون هزینه …</span>
                        </div>
                        <div className="total-price persian-number">
                            <IconName name="cart" className="icon"/>
                            <span>5,480,000 ت</span>
                        </div>
                    </div>
                    <div className="seller-box-responsive">
                        <div className="name-seller position-relative">
                            <IconName name="vendor" className="icon icon-seller"/>
                            <span className="name">کامپیوتر زرد آذربایجان</span>
                            <span className="ok-seller">
                                <IconName name="check" className="icon"/>
                                برگزیده
                            </span>
                            <IconName name="chevron_left" className="icon more-sellers position-absolute"/>
                        </div>
                        <div className="function-seller">
                            <IconName name="stars" className="icon"/>
                            <p><span>عملکرد ۳.۴ از ۵</span> (عضویت از ۱ سال، ۶ ماه پیش)</p>
                            <div className="score-sellers">
                                <ul className="nav">
                                    <li className="nav-item">
                                        <span className="score persian-number good-score">100%</span>
                                        <span className="text-score">تامین به موقع</span>
                                    </li>
                                    <li className="nav-item">
                                        <span className="score persian-number bad-score">93.4%</span>
                                        <span className="text-score">تعهد ارسال</span>
                                    </li>
                                    <li className="nav-item">
                                        <span className="score persian-number good-score">95%</span>
                                        <span className="text-score">بدون مرجوعی</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="register-product">
                            <IconName name="verified_user" className="icon"/>
                            <span>تضمین ثبت در شبکه رجیستری بدون هزینه …</span>
                        </div>
                        <div className="total-price persian-number">
                            <IconName name="cart" className="icon"/>
                            <span>5,480,000 ت</span>
                        </div>
                    </div>
                    <div className="seller-box-responsive">
                        <div className="name-seller position-relative">
                            <IconName name="vendor" className="icon icon-seller"/>
                            <span className="name">کامپیوتر زرد آذربایجان</span>
                            <span className="ok-seller">
                                <IconName name="check" className="icon"/>
                                برگزیده
                            </span>
                            <IconName name="chevron_left" className="icon more-sellers position-absolute"/>
                        </div>
                        <div className="function-seller">
                            <IconName name="stars" className="icon"/>
                            <p><span>عملکرد ۳.۴ از ۵</span> (عضویت از ۱ سال، ۶ ماه پیش)</p>
                            <div className="score-sellers">
                                <ul className="nav">
                                    <li className="nav-item">
                                        <span className="score persian-number good-score">100%</span>
                                        <span className="text-score">تامین به موقع</span>
                                    </li>
                                    <li className="nav-item">
                                        <span className="score persian-number bad-score">93.4%</span>
                                        <span className="text-score">تعهد ارسال</span>
                                    </li>
                                    <li className="nav-item">
                                        <span className="score persian-number good-score">95%</span>
                                        <span className="text-score">بدون مرجوعی</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="register-product">
                            <IconName name="verified_user" className="icon"/>
                            <span>تضمین ثبت در شبکه رجیستری بدون هزینه …</span>
                        </div>
                        <div className="total-price persian-number">
                            <IconName name="cart" className="icon"/>
                            <span>5,480,000 ت</span>
                        </div>
                    </div>
                    <div className="seller-box-responsive">
                        <div className="name-seller position-relative">
                            <IconName name="vendor" className="icon icon-seller"/>
                            <span className="name">کامپیوتر زرد آذربایجان</span>
                            <span className="ok-seller">
                                <IconName name="check" className="icon"/>
                                برگزیده
                            </span>
                            <IconName name="chevron_left" className="icon more-sellers position-absolute"/>
                        </div>
                        <div className="function-seller">
                            <IconName name="stars" className="icon"/>
                            <p><span>عملکرد ۳.۴ از ۵</span> (عضویت از ۱ سال، ۶ ماه پیش)</p>
                            <div className="score-sellers">
                                <ul className="nav">
                                    <li className="nav-item">
                                        <span className="score persian-number good-score">100%</span>
                                        <span className="text-score">تامین به موقع</span>
                                    </li>
                                    <li className="nav-item">
                                        <span className="score persian-number bad-score">93.4%</span>
                                        <span className="text-score">تعهد ارسال</span>
                                    </li>
                                    <li className="nav-item">
                                        <span className="score persian-number good-score">95%</span>
                                        <span className="text-score">بدون مرجوعی</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="register-product">
                            <IconName name="verified_user" className="icon"/>
                            <span>تضمین ثبت در شبکه رجیستری بدون هزینه …</span>
                        </div>
                        <div className="total-price persian-number">
                            <IconName name="cart" className="icon"/>
                            <span>5,480,000 ت</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sellers;
